<template>
  <div id="BaseHeader" class="noprint">
    <HeaderTopBar
      :theme="tenantDetails.theme"
      :should-show-nav-icons="shouldShowNavIcons"
      @openSideCart="openSideCart"
    />
    <HeaderSearchBar
      :should-show-search-controls="shouldShowSearchControls"
    />
    <HeaderMainMenu v-if="shouldShowMainMenu" class="d-none d-sm-block"/>

    <HeaderMainMenuSmScreen v-if="shouldShowMainMenu" class="d-block d-sm-none d-md-none d-lg-none"/>

    <div v-if="shouldShowNavIcons" class="container">
      <breadcrumbs />
    </div>
  </div>
</template>

<script>
  import { mapGetters } from "vuex"
  import HeaderTopBar from "@/components/Header/HeaderTopBar"
  import HeaderSearchBar from "@/components/Header/HeaderSearchBar.vue"
  import HeaderMainMenu from "@/components/Header/HeaderMainMenu"
  import HeaderMainMenuSmScreen from "@/components/Header/HeaderMainMenuSmScreen"
  import Breadcrumbs from "@/components/Header/Breadcrumbs"

  export default {
    components: {
      HeaderTopBar,
      HeaderSearchBar,
      HeaderMainMenu,
      HeaderMainMenuSmScreen,
      Breadcrumbs, 
    },
    props: {
      shouldShowNavIcons: {
        type: Boolean,
        default: true
      },
      shouldShowSearchControls: {
        type: Boolean,
        default: true
      },
      shouldShowMainMenu: {
        type: Boolean,
        default: true
      }
    },
    computed: {
      ...mapGetters(["tenantDetails"])
    },
    methods: {
      openSideCart(){
        this.$emit("openSideCart");
      }
    }
  }
</script>
